import { resourceReducer, getResources } from 'redux-resource';

export default resourceReducer('bypassedPlans');

export const getAllPlans = (state) => getResources(state);
export const getPlan = (state, id) => state.resources[id];
